/* Built In Imports */

/* External Imports */
import { Box, Image } from '@chakra-ui/react';
import TopKolam from '@components/Headings/TopKolam';
import { useEffect, useRef, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { TabContent } from '../components/TabContent';

/* Internal Imports */
/* Components */

/**
 * Renders the ImageBannerAd Card component
 *
 * @param sectionContent.sectionContent
 * @param {object} sectionContent - Data for section
 * @param {string} region - Region for page
 * @param {Sting} lang - Language for page
 * @param sectionContent.region
 * @param sectionContent.lang
 * @param sectionContent.width
 * @param sectionContent.height
 * @param sectionContent.my
 * @param sectionContent.display
 * @param sectionContent.maxW
 * @returns {ReactElement} ImageBannerAd component
 */
const Projects = ({
    section, region, language
}) => {

    const isMobile = useMediaQuery({ maxWidth: 868 });
    const [activeTab, setActiveTab] = useState(0);
    const tabContentRef = useRef(null);
    const [scrollPosition, setScrollPosition] = useState(0);
    const initialRender = useRef(true);
    const handleTabClick = (index) => {
        setActiveTab(index);
    };

    useEffect(() => {
        if (initialRender.current) {
            initialRender.current = false;
        } else {
            const element = document.getElementById("content");
            if (element.scrollHeight > window.innerHeight) {
                element.scrollIntoView();
            }
        }
    }, [activeTab]);

    return (
        <Box
            width={"100%"}
            padding={{ base: "60px 0px 0px 0px", sm: "60px 0px 0px 0px", md: "80px 0px 0px 0px" }}
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
        >
            <Box
                id="content"
                display={"flex"}
                flexDirection={"column"}
                justifyContent={"center"}
                alignItems={"center"}
            >
                <Box
                    position={{ base: 'sticky', lg: 'sticky', md: 'sticky' }}
                    top="0"
                    zIndex={5}
                    background="#ffffff"
                    width="100%"
                    textAlign={'center'}
                    paddingBottom={{ base: '0px', md: '30px' }}
                >
                    <Box
                        height={"100px"}
                    >
                        <Box

                            display={"flex"}
                            justifyContent={"center"}
                            alignItems={"center"}
                            fontSize={{ base: "30px", sm: "30px", lg: "30px" }}
                            fontWeight={"semibold"}
                            color={"#000000"}
                            lineHeight={"40px"}
                        >
                            {section?.sectionContent[0]?.titleText}
                        </Box>
                        <Box
                            marginLeft={"-10px"}
                            marginTop={{ sm: "-15px", base: "-15px", lg: "-15px" }}
                        >
                            <TopKolam sectionContent={section?.sectionContent[1]} />
                        </Box>
                    </Box>
                    <Box
                        marginTop={{ sm: "10px", base: "10px", lg: "0px" }}
                    >
                        <Image src={section?.sectionContent[1]?.image?.url} />
                    </Box>
                    {
                        isMobile ?
                            <Box
                                display={'flex'}
                            >
                                {section?.sectionContent[8]?.images.map((item, index) => (
                                    <Box
                                        position={"relative"}
                                    >
                                        <Box
                                            key={index}
                                            color={"#000"}
                                            display={"flex"}
                                            justifyContent={"center"}
                                            alignItems={"center"}
                                            font-family={"Fedra Serif A Std"}
                                            fontSize="22px"
                                            fontWeight="semibold"
                                            lineHeight="124%"
                                            padding={"0px 39px"}
                                            textAlign="center" maxHeight="400px"
                                            borderRight={index === 0 || index === 1 ? "2px solid #000" : "none"}
                                            onClick={() => handleTabClick(index)}
                                            cursor="pointer"
                                            position={"relative"}
                                        >
                                            <Box
                                                display={'flex'}
                                            >
                                                <Box display={"flex"}
                                                    justifyContent={"center"}
                                                    alignItems={"center"}>
                                                    <Image
                                                        src={item?.url}

                                                    />
                                                </Box>
                                            </Box>
                                        </Box>
                                        {activeTab === index && (
                                            <Box
                                                style={{
                                                    position: "absolute",
                                                    top: "50px",
                                                    left: "32px",
                                                    height: "5px",
                                                    width: "50px",
                                                    backgroundColor: "#721B0F",
                                                }
                                                } />
                                        )}
                                    </Box>
                                ))}
                            </Box>
                            :
                            <Box
                                display={{ sm: "none", base: "none", md: "flex" }}
                                width={{ md: "972px" }}
                                justifyContent={'space-between'}
                                mt="10px"
                            >
                                {[
                                    { index: 2, padding: "0px 50px", left: "0px", borderRight: "2px solid #000" },
                                    { index: 4, padding: "0px 90px", left: "40px", borderRight: "2px solid #000" },
                                    { index: 6, padding: "0px 16px", left: "90px", borderRight: "none" },
                                ].map((item, index) => (
                                    <Box
                                        key={index}
                                        color={"#000"}
                                        display={"flex"}
                                        justifyContent={"center"}
                                        alignItems={"center"}
                                        font-family={"Fedra Serif A Std"}
                                        fontSize="22px"
                                        fontWeight="semibold"
                                        lineHeight="124%"
                                        padding={item.padding}
                                        textAlign="center" maxHeight="400px"
                                        borderRight={item.borderRight}
                                        onClick={() => handleTabClick(index)}
                                        cursor="pointer"
                                        width={'33%'}
                                    // position={"relative"}
                                    >
                                        <Box
                                            width={index === 2 ? "350px" : ""} position={'relative'} minH={'35px'}
                                        >
                                            {section?.sectionContent[item.index]?.titleText}

                                            {activeTab === index && (
                                                <Box
                                                    style={{
                                                        position: "absolute",
                                                        top: index > 1 ? '70px' : "60px",
                                                        left: '50%',
                                                        // marginTop: index === 2 ? "0px" : "29px",
                                                        height: "5px",
                                                        width: "100%",
                                                        backgroundColor: "#721B0F",
                                                    }
                                                    } transform={'translateX(-50%)'} />
                                            )}
                                        </Box>

                                    </Box>
                                ))}
                            </Box>
                    }
                    <Box
                        display={{ sm: "block", base: "block", md: "none" }}
                    >
                        {[
                            { index: 2, padding: "0px 80px", borderRight: "2px solid #000" },
                            { index: 4, padding: "0px 85px", borderRight: "2px solid #000" },
                            { index: 6, padding: "0px 50px", borderRight: "none" },
                        ].map((item, index) => (
                            <Box
                                fontWeight={"semibold"}
                                fontSize={"18px"}
                                margin={"30px 0px 30px 0px"}

                            // margin={index === 0 || index === 1 ? "30px 0px 0px 0px" : { base: '20px 0px 0px 0px', md: '30px 0px 20px 0px' }}
                            >
                                {activeTab === index && section?.sectionContent[item.index]?.titleText}
                            </Box>
                        ))}
                    </Box>
                </Box>
                <Box

                    marginTop={{ md: "30px" }}
                >
                    {activeTab === 0 ? (
                        section?.sectionContent[3]?.tabContent.map((tab, index) => (
                            <Box
                                key={index}
                                background="#F5F0E5"
                                padding={{ md: "40px" }}
                                width={{ lg: "972px" }}
                                marginBottom={{ lg: "30px" }}
                            >
                                <TabContent title={tab?.title} content={tab?.content} />
                            </Box>
                        ))
                    ) : activeTab === 1 ? (
                        section?.sectionContent[5]?.tabContent.map((tab, index) => (
                            <Box
                                key={index}
                                background="#F5F0E5"
                                padding={{ md: "40px" }}
                                width={{ lg: "972px" }}
                                marginBottom={{ lg: "30px" }}
                            >
                                <TabContent title={tab?.title} content={tab?.content} />
                            </Box>
                        ))
                    ) : activeTab === 2 ? (
                        section?.sectionContent[7]?.tabContent.map((tab, index) => (
                            <Box
                                key={index}
                                background="#F5F0E5"
                                padding={{ md: "40px" }}
                                width={{ lg: "972px" }}
                                marginBottom={{ lg: "30px" }}
                            >
                                <TabContent title={tab?.title} content={tab?.content} />
                            </Box>
                        ))
                    ) : null}
                </Box>

            </Box>
        </Box >
    );
};

export default Projects;
